<template lang="pug">
.wrapper
  button.samtek-btn-primary(
    type="button"
    id="botones-options-client"
    @click="confirm(newCustomer ? 'create' : 'edit')"
  )
    | {{ newCustomer ? 'Crear cliente' : 'Confirmar' }}

  button.samtek-btn-secondary(
    type="button"
    v-if="editing && !newCustomer"
    @click="$emit('cancel')"
  )
    | Cancelar

  button.samtek-btn-secondary(
    type="button"
    :disabled="loading"
    v-if="!editing && !newCustomer"
    @click="$emit('edit')"
  )
    | Editar
</template>

<script>
export default {
  props: {
    editing: Boolean,
    newCustomer: Boolean,
    rutLoaded: Boolean,
    loading: Boolean,
    confirm: Function,
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.wrapper {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }
}

.samtek-btn-primary {
  min-width: 140px;
  height: 45px;
  padding: 10px 20px;
  background-color: #FECE2F;
  color: #23201C;
  border: none;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover { opacity: 0.88; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }

  @include media-breakpoint-down(sm) { width: 100%; }
}

.samtek-btn-secondary {
  min-width: 140px;
  height: 45px;
  padding: 10px 20px;
  background-color: #F5F6FA;
  color: #23201C;
  border: 1px solid #525252;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover { background-color: #e8e9ef; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }

  @include media-breakpoint-down(sm) { width: 100%; }
}
</style>
